// extracted by mini-css-extract-plugin
export default {"statBox":"provider_statBox__PL1vz","statBoxNumber":"provider_statBoxNumber__YJ7xW","statBoxLabel":"provider_statBoxLabel__8lADl"};